import _ from 'lodash'

export default (object: any, path: string, defaultValue: any = '-'): any => {
  return _.get(object, path, defaultValue)
}
